import { axiosClient } from '../../../../services/axiosInstance'
import type { OrderFormAPI } from '../types'
import { OrderForm } from '../../entity/orderForm'

export const addCartMarketingData = async (
  orderFormId: string,
  body: OrderFormAPI['marketingData']
) => {
  try {
    const { data } = await axiosClient.post(
      `/api/checkout/orderForm/${orderFormId}/marketingData`,
      body
    )

    return new OrderForm(data)
  } catch (error) {
    throw new Error(error)
  }
}
